import { Injectable } from '@angular/core';
import {
  State, Action, StateContext, Selector,
} from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { UsersService } from '@core/services/users.service';
import { AdminListResponse, User, UsersFilter } from '@core/interfaces/users.interface';
import { ApolloQueryResult } from '@apollo/client/core';
import {
  ArchiveUser,
  CreateAdmin,
  GetListUsers,
  ResetUsersFilter,
  SetUsersFilter,
  UpdateUser,
} from '../action/users.action';

export class UsersStateModel {
  users!: Array<User>;

  total!: number | null;

  filter!: UsersFilter;
}

@State<UsersStateModel>({
  name: 'UsersState',
  defaults: {
    users: [],
    total: null,
    filter: {},
  },
})
@Injectable()
export class UsersState {
  constructor(private usersService: UsersService) {}

  @Selector()
  static getUsers(state: UsersStateModel): any {
    return state.users;
  }

  @Selector()
  static getUsersFilter(state: UsersStateModel): any {
    return state.filter;
  }

  @Action(GetListUsers)
  public getListUsers(
    ctx: StateContext<UsersStateModel>,
    { params }: GetListUsers,
  ): Observable<ApolloQueryResult<AdminListResponse>> {
    return this.usersService.getListUser(params!).pipe(
      tap((res) => {
        if (res && res.data) {
          ctx.patchState({ users: res.data.getListAdmin.result });
          ctx.patchState({ total: res.data.getListAdmin.total });
        }
      }),
    );
  }

  @Action(CreateAdmin)
  public createAdmin(ctx: StateContext<UsersStateModel>, { user }: CreateAdmin): void {
    const currentState = ctx.getState();
    const updatedVehicles = [...currentState.users, user];
    ctx.patchState({
      users: updatedVehicles,
    });
  }

  @Action(UpdateUser)
  public updateUser(ctx: StateContext<UsersStateModel>, { user }: UpdateUser): void {
    const currentState = ctx.getState();

    const updatedUsers = [...currentState.users];
    const userIndex = updatedUsers.findIndex((v) => v.id === user.id);

    if (userIndex !== -1) {
      updatedUsers[userIndex] = { ...updatedUsers[userIndex], ...user };
    }

    ctx.patchState({
      users: updatedUsers,
    });
  }

  @Action(ArchiveUser)
  public archiveVehicle(ctx: StateContext<UsersStateModel>, { id }: ArchiveUser): void {
    const currentState = ctx.getState();

    const updatedVehicles = currentState.users.filter((user) => user.id !== id);

    ctx.patchState({
      users: updatedVehicles,
    });
  }

  @Action(SetUsersFilter)
  public SetUsersFilter(ctx: StateContext<UsersStateModel>, { filter }: SetUsersFilter): void {
    ctx.patchState({ filter });
  }

  @Action(ResetUsersFilter)
  public resetFilter(ctx: StateContext<UsersStateModel>): void {
    ctx.patchState({
      filter: {},
    });
  }
}
